import React from 'react'
import AdmResult from '../../components/AdminTabs/AdminResult/ResultPublishs'

const AdminResult = () => {
  return (
    <div>
      <AdmResult/>
    </div>
  )
}

export default AdminResult
